import { useEffect, useState } from "react";
import { Container, useMediaQuery } from "@mui/material";
import { ShopShirtInterface } from "../../services/shirts/types";
import ShopShirtModelFilters from "../../components/ShopShirtModelFilters/ShopShirtModelFilters";
import ShopItemsList from "../../components/ShopItemsList/ShopItemsList";
import PageControllers from "../../components/PageControllers/PageControllers";
import MenuService from "../../components/Menu/menuService";

const Store = () => {
  const [shirts, setShirts] = useState<Array<ShopShirtInterface>>([]);
  const [page, setPage] = useState<number>(1);
  const [lastPage, setLastPage] = useState<number | undefined>(undefined);
  const [totalFound, setTotalFound] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>();

  const { selectPage } = MenuService();
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    selectPage("menu-store");
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  useEffect(() => {
    setItemsPerPage(isMobile ? 10 : 24);
  }, [isMobile]);

  return (
    <Container
      maxWidth={false}
      sx={{
        paddingY: { xs: "2rem", sm: "3rem" },
        paddingX: "0rem !important",
        backgroundColor: "#f4f6f8",
      }}
    >
      {itemsPerPage && (
        <Container maxWidth={"lg"}>
          <ShopShirtModelFilters
            setShirts={setShirts}
            page={page}
            setTotalFound={setTotalFound}
            setLastPage={setLastPage}
            itemsPerPage={itemsPerPage}
          />
          <ShopItemsList shirts={shirts} total={totalFound} />
          {shirts.length > 0 && (
            <PageControllers
              setPage={setPage}
              currentPage={page}
              lastPage={lastPage}
              withNumbers={true}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
            />
          )}
        </Container>
      )}
    </Container>
  );
};

export default Store;
